import React, { useEffect, useMemo, useState } from 'react';
import styles from './DataPreview.module.scss';
import Header from 'component/layout/header/Header';
import Button from 'component/atom/forms/button/Button';
import TableComponent from 'component/molecules/Table/TableComponent';
import { useLocation, useParams } from 'react-router-dom';
import { Agent } from 'hooks/endpoints';
import { exportData } from 'helpers/exportData';

const excludedKeys = ['InternalId', 'DateInsertedOn', 'AgentId', 'Id'];

const getItemsArray = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

const humanize = (k) =>
  k
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim();

const DataPreview = () => {
  const { botId } = useParams();
  const location = useLocation();
  const detailId = location.state?.detailId;

  const [data, setData] = useState();
  const [headerData, setHeaderData] = useState({
    tableName: 'Data Preview',
    hasPaging: true,
    hasSearch: true,
    fields: [],
  });

  const items = useMemo(() => getItemsArray(data), [data]);
  const firstRow =
    items.length > 0 && typeof items[0] === 'object' ? items[0] : null;

  useEffect(() => {
    if (!firstRow) return;

    const fields = Object.keys(firstRow)
      .filter((key) => !excludedKeys.includes(key))
      .map((key) => ({
        fieldName: key,
        headerName: humanize(key),
      }));

    setHeaderData((prev) => ({
      ...prev,
      fields,
    }));
  }, [firstRow]);

  const rowKey = useMemo(() => {
    if (!firstRow) return 'id';
    const candidates = ['id', 'Id', 'ID'];
    return candidates.find((c) => c in firstRow) || 'Id';
  }, [firstRow]);
  const handleExport = async () => {
    exportData(
      Agent.exportTableDataToCSV(detailId),
      data?.agentTypeConnection?.endpoint
    );
  };

  return (
    <div className={styles['data-preview-container']}>
      <Header title='Data Preview' isBack isSub />
      <div className={styles['table-card']}>
        <div className={styles['table-header']}>
          <div className={styles['table-header-wrapper']}>
            <div className={styles['table-title-container']}>
              <span className={styles['title']}>
                {data?.agentTypeConnection?.description || '—'}
              </span>
              <div className={styles['info-container']}>
                {0 !== data?.totalCount && (
                  <div
                    className={`${styles.custom} ${styles.status} ${styles.testSuccess}`}
                  >
                    <div className={`${styles.circle} ${styles.healthy}`}></div>
                    Healthy
                  </div>
                )}
                <div className={styles['url-container']}>
                  <p>{data?.agentTypeConnection?.endpoint || '—'}</p>
                </div>
                <span className={styles['records']}>
                  Record: {data?.totalCount ?? items.length ?? 0}
                </span>
                <span className={styles['records']}>
                  Fields: {headerData?.fields?.length || 0}
                </span>
              </div>
            </div>
            <Button
              label='Export'
              type='download'
              disabled={!items.length}
              onClick={handleExport}
            />
          </div>
        </div>

        {headerData && (
          <TableComponent
            rowKey={rowKey}
            headerData={headerData}
            api={{
              get: {
                url: Agent.getTableData(detailId),
                queryKey: ['agent-table-data', botId, detailId],
                enabled: Boolean(detailId),
              },
            }}
            getData={(resp) => {
              if (resp) setData(resp);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default DataPreview;
